import { z } from 'zod';

const medicalHistoryStatusRequired = z
    .enum(['0', '2', '3', '-1', ''])
    .refine((value) => value !== '', { message: 'Required' });

export const assessLiverHealthSchema = z.object({
    historyLiverDisease: medicalHistoryStatusRequired,
    hasHepB: medicalHistoryStatusRequired,
    hasHepC: medicalHistoryStatusRequired,
});
